import InputCombobox, { type InputComboboxProps } from './InputCombobox';

export type { InputComboboxProps };
export default InputCombobox;
